import { normalize } from './normalize.js';

/**
 * Normalizes the label depending on label type
 *
 * @param label -
 */
export function formatLabel(label: string | undefined): string | undefined {
  if (!label) {
    return;
  }

  return normalize(label);
}
